import axios from "axios";
import Config from "../../../config";

const v2_actionDeleteLeadTag = (tagId) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/lead-tags/${tagId}/deletar`
    });
};

export default v2_actionDeleteLeadTag;
